__turbopack_context__.v({
  "optionCustom": "styles-module__OfHJDq__optionCustom",
  "optionSubtext": "styles-module__OfHJDq__optionSubtext",
  "textfieldFreeformOption": "styles-module__OfHJDq__textfieldFreeformOption",
});
